import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Button, Card, CardContent, Divider, Paper, Typography, } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteUser, useRetrievePlayerByUserId } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { UserContext } from "./UserProvider";
const MyAccount = () => {
    const { user, loading, setUser, setLoading } = useContext(UserContext);
    const navigate = useNavigate();
    const { data: player, isLoading: isPlayerLoading, isError: isPlayerError, } = useRetrievePlayerByUserId({ userId: user?.pk });
    const deleteUserMutation = useDeleteUser({
        onSuccess: () => {
            setUser(null);
            setLoading(false);
            navigate("/");
        },
        onError: () => { },
        onMutate: () => { },
    });
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    if (loading || isPlayerLoading) {
        return _jsx(Loading, {});
    }
    if (!user || !player || isPlayerError) {
        return _jsx(ErrorView, { error: "Error retrieving user details" });
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", {
            month: "long",
            year: "numeric",
        }).format(date);
    };
    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
    };
    const displayName = playerDisplayName(player);
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: deleteUserMutation.isError, message: "Failed to delete user!" }), _jsxs(Card, { sx: { maxWidth: 400, margin: "auto", mt: 4 }, children: [_jsxs(CardContent, { children: [_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", children: [_jsx(Avatar, { alt: displayName, src: user?.picture ?? undefined, sx: { width: 80, height: 80, mb: 2 } }), _jsx(Typography, { variant: "h6", children: displayName }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: user.email }), _jsxs(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1 }, children: ["Member since: ", formatDate(player.createdAt)] })] }), _jsx(Divider, { sx: { my: 3 } }), _jsxs(Paper, { sx: { p: 2, backgroundColor: "#ffe6e6" }, children: [_jsx(Typography, { variant: "body1", color: "error", sx: { fontWeight: "bold", mb: 1 }, children: "Danger Zone" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: "Deleting your account is permanent and cannot be undone. Please proceed with caution." }), _jsx(Button, { variant: "contained", color: "error", onClick: handleDeleteClick, fullWidth: true, sx: { fontWeight: "bold" }, children: "Delete Account" })] })] }), _jsx(DeleteDialog, { open: openDeleteDialog, title: "Delete your account?", onCancel: () => {
                            setOpenDeleteDialog(false);
                        }, onConfirm: () => {
                            deleteUserMutation.mutate();
                        } })] })] }));
};
export default MyAccount;
